/// <reference types="jest" />

export const FeatureFlags = {
  // PERMANENT
  IS_BYPASS_PAS_ENABLED: {
    name: 'is-bypass-pas-enabled',
    value: false,
  },
  // TEMPORARY
  // TODO: cleanup https://app.asana.com/0/1203421084024823/1209793126158993
  IS_SEND_FROM_EMMA_PRO_TO_BROKERAGE: {
    name: 'is-send-from-emma-pro-to-brokerage',
    value: false,
  },
  // TODO: cleanup https://app.asana.com/0/1203421084024823/1209570477269193
  IS_BLOCK_SECONDARY_AGENT_ENABLED: {
    name: 'is-block-secondary-agent-enabled',
    value: false,
  },
  // TODO: cleanup https://app.asana.com/1/1201402279806980/project/1202629821924407/task/1208602524518887
  IS_MANUALLY_ADDED_TO_CONTRACT_ENABLED: {
    name: 'is-manually-added-to-contract-enabled',
    value: false,
  },
  // TODO: cleanup https://app.asana.com/1/1201402279806980/project/1203421084024823/task/1210125048808068
  IS_NEW_COVERAGE_BUILDER_ENABLED: {
    name: 'is-new-coverage-builder-enabled',
    value: false,
  },
  // TODO: cleanup https://app.asana.com/1/1201402279806980/project/1203421084024823/task/1210221229089110
  IS_NEW_NEW_QUOTE_PAGE_NEW_ENABLED: {
    name: 'is-new-new-quote-page-enabled',
    value: false,
  },
  // TODO: cleanup https://app.asana.com/1/1201402279806980/project/1203421084024823/task/1210342510029486
  IS_UP_POLICY_REPLACEMENT_DOWNLOAD_ENABLED: {
    name: 'is-up-policy-replacement-download-enabled',
    value: false,
  },
  // TODO: cleanup https://app.asana.com/1/1201402279806980/project/1203421084024823/task/1210342301078568
  IS_PAS_ERROR_REFACTOR_ENABLED: {
    name: 'is-pas-error-refactor-enabled',
    value: false,
  },
  // TODO: cleanup https://app.asana.com/1/1201402279806980/project/1203421084024823/task/1210400850191007
  IS_ADD_EXTRA_DOCUMENTS_IN_CONTRACT_ENABLED: {
    name: 'is-add-extra-documents-in-contract-enabled',
    value: false,
  },
  // TODO: cleanup https://app.asana.com/1/1201402279806980/project/1203421084024823/task/1210499569512348
  IS_EXTERNAL_SR_EMAIL_ZIPPING_ENABLED: {
    name: 'is-external-sr-email-zipping-enabled',
    value: false,
  },
  // TODO: cleanup after testing server-side pagination
  IS_SERVER_SIDE_PAGINATION_ENABLED: {
    name: 'is-server-side-pagination-enabled',
    value: false,
  },
};

export type FeatureFlag = (typeof FeatureFlags)[keyof typeof FeatureFlags];

export function getFeatureFlagValue(
  featureFlags: {
    featureFlag: {
      name: string;
      value: boolean;
    };
    featureFlagValue: boolean;
  }[],
  targetFeatureFlag: {
    name: string;
    value: boolean;
  },
): boolean {
  const featureFlag = featureFlags.find((ff) => ff.featureFlag === targetFeatureFlag);
  return featureFlag ? featureFlag.featureFlagValue : false;
}

export function mockFeatureFlagOn(
  featureFlagService: {isEnabled: (flag: FeatureFlag) => Promise<boolean>},
  targetFlag: FeatureFlag,
) {
  jest.spyOn(featureFlagService, 'isEnabled').mockImplementation((flag) => {
    return Promise.resolve(flag === targetFlag);
  });
}

export function mockFeatureFlagOff(
  featureFlagService: {isEnabled: (flag: FeatureFlag) => Promise<boolean>},
  targetFlag: FeatureFlag,
) {
  jest.spyOn(featureFlagService, 'isEnabled').mockImplementation((flag) => {
    return Promise.resolve(flag !== targetFlag);
  });
}
